import(/* webpackMode: "eager", webpackExports: ["PublicTitleDetailPanel"] */ "/workspace/src/components/public/title-panels.tsx");
